// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3ukQF","col":"styles_col__j3UOz"};